export interface BaseFullscreenFrameProps {
    isSidebarHidden?: boolean;
    isAnimatable?: boolean;
    scrollable?: boolean;
}
export const fullscreenFrameSidebarWidth = '400px';
export const fullscreenTransition = '0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946)';
